<div class="model-info-wrapper">
  <div class="d-flex justify-space-between">
    <div class="d-flex gap=-10">
      <img alt="back" (click)="dialogRef.close()" class="cursor"
        src="../../../../assets/images/arrow_menu_close.svg" />&nbsp;
      <span class="card-title">Model Info</span>
    </div>
    <mat-slide-toggle color="#055C7B" [checked]="data?.routeData?.prescriptiveInsight" [disabled]="false"
      class="uni-profile-pop" matTooltip="Prescriptive Insight">
    </mat-slide-toggle>
  </div>
  <div class="mt-3">
    <div class="responsive-model-info">
      <div class="info-row" *ngFor="let detail of modelInfoDetails">
        <div class="label">{{ detail?.label }}</div>
        <div class="value">{{ detail?.value ?? '-' }}</div>
      </div>
    </div>
    <div class="mt-5">
      <mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedTabIndex">
        <mat-tab label="{{tab.label}}" *ngFor="let tab of catalogueConfig?.modelInfoTab; let i = index">
          <div [ngSwitch]="tab?.id">
            <div *ngSwitchCase="'modelParameter'">
              <div class="mt-2">
                <span class="tab-body-title">File Added</span>
                <div class="file-container">
                  <div class="d-flex justify-space-between">
                    <div class="d-flex">
                      <img alt="file" src="../../../../assets/images/bi_file-earmark-image.svg">&nbsp;&nbsp;&nbsp;
                      <span class="file-name">{{ catalogueConfig?.modelFileName }}</span>&nbsp;&nbsp;
                      <span class="dot"></span>&nbsp;&nbsp;
                      <span class="preview-text">Preview</span>
                    </div>
                    <div class="file-size">
                      {{ catalogueConfig?.modelFileSize }}
                    </div>
                  </div>
                </div>
                <div class="parameter-container">
                  <div *ngFor="let parameter of catalogueConfig?.modelParameters">
                    <div class="mt-2">
                      <div class="d-flex justify-space-between align-items-baseline">
                        <span class="param-name">{{ parameter?.name }}</span>
                        <span class="param-value"> {{ parameter?.value }}</span>
                      </div>
                      <mat-progress-bar class="mt-2" mode="determinate"
                        [value]="getProgressValue(parameter?.value, parameter?.maxLimit)"></mat-progress-bar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="'dataParameter'">
              <div class="mt-2">
                <span class="tab-body-title">File Added</span>
                <div class="file-container">
                  <div class="d-flex justify-space-between">
                    <div class="d-flex">
                      <img alt="file" src="../../../../assets/images/bi_file-earmark-image.svg">&nbsp;&nbsp;&nbsp;
                      <span class="file-name">{{ catalogueConfig?.dataFileName }}</span>&nbsp;&nbsp;
                      <span class="dot"></span>&nbsp;&nbsp;
                      <span class="preview-text">Preview</span>
                    </div>
                    <div class="file-size">
                      {{ catalogueConfig?.dataFileSize }}
                    </div>
                  </div>
                </div>
                <div class="parameter-container">
                  <div *ngFor="let parameter of catalogueConfig?.dataParameters">
                    <div class="mt-2">
                      <div class="d-flex justify-space-between align-items-baseline">
                        <span class="param-name">{{ parameter?.name }}</span>
                        <span class="param-value"> {{ parameter?.value }}</span>
                      </div>
                      <mat-progress-bar class="mt-2" mode="determinate"
                        [value]="getProgressValue(parameter?.value, parameter?.maxLimit)"></mat-progress-bar>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>